export default {
  "content": "<g clip-path=\"url(#clip0_773_12573)\" fill=\"#5C6270\"><path d=\"M10.65 11.582H5.34A3.34 3.34 0 002 14.922v1.46c0 .29.24.53.53.53h10.93c.29 0 .53-.24.53-.53v-1.46a3.327 3.327 0 00-3.34-3.34zM2.74 8.912c.46 1.07.27 1.81.22 1.97-.01.01.01.03.02.03.59-.03 1.39-.44 1.24-1.8-.14-1.35.56-1.59.88-1.74.23 1.03 1.03 3.54 3.39 3.54 3.06 0 3.48-3.97 3.48-3.97.01-.03.58-4.7-3.48-4.7-.35 0-.65.04-.93.11-.27-.6-1.01-1.85-2.35-1.31-2.11.85-1.31 2.82-1.01 3.43.45.93-2.91 1.03-1.46 4.44z\"/></g><defs><clipPath id=\"clip0_773_12573\"><path fill=\"#fff\" transform=\"translate(0 .912)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "17",
    "viewBox": "0 0 16 17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};